import Decimal from 'decimal.js';

interface ConversionToFiat {
	amount: string;
	exchangeRate: string;
}

export const convertToFiat = ({ amount, exchangeRate }: ConversionToFiat) => {
	if (!exchangeRate || !amount) return '0.00';

	const result = new Decimal(amount).div(new Decimal(exchangeRate));
	const rounded = result;

	return rounded.toNumber().toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

// .toLocaleString('en-US', {
// 		minimumFractionDigits: 2,
// 		maximumFractionDigits: 2,
// 	});
